export default __webpack_public_path__ + "static/media/howto2.b657b02c.png";